/**
 * Warm the TLS connection to the media origin before anything needs it.
 *
 * The match video and the tracking parquet are fetched from R2 with
 * presigned URLs. The browser only learns those URLs after the game-info
 * fetch resolves, so without this the R2 TCP+TLS handshake sits in SERIES
 * behind that fetch on the video's critical path. Preconnecting when the
 * session arrives (app boot) runs the handshake in parallel with the data
 * fetches instead.
 *
 * crossorigin matters: the video element uses crossorigin="anonymous", and
 * a preconnect without it opens a connection pool the CORS fetch will not
 * reuse.
 */
export function ensurePreconnect(origin: string | null | undefined): void {
  if (!origin) return
  let normalized: string
  try {
    normalized = new URL(origin).origin
  } catch {
    return // a malformed origin is not worth an exception at boot
  }
  if (document.head.querySelector(
    `link[rel="preconnect"][href="${normalized}"]`)) return
  const link = document.createElement('link')
  link.rel = 'preconnect'
  link.href = normalized
  link.crossOrigin = 'anonymous'
  document.head.appendChild(link)
}
